import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import React from 'react';
import warning from 'warning';
import get from 'lodash/get';
import { colornames } from '@vpp-frontend-components/common';
import { useVppContext } from '@vpp-frontend-components/vpp-context';
import _extends from '@babel/runtime/helpers/extends';
import _jsx from '@babel/runtime/helpers/jsx';
var _path;

/**
 * DefaultSVGIcon component
 * @typedef {import('../../index').DefaultSVGIcon}
 */
const DefaultSVGIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  version: "1.1",
  viewBox: "0.00 0.00 512.00 512.00",
  width: 16,
  height: 16
}, props), _path || (_path = /*#__PURE__*/_jsx("path", {
  d: "M7.15 0C8.743 0 10.214 0.520999 11.403 1.402L10.441 2.312C9.503 1.674 8.371 1.3 7.15 1.3C3.92 1.3 1.3 3.92 1.3 7.15C1.3 10.38 3.92 13 7.15 13C10.38 13 13 10.38 13 7.15C13 6.824 12.973 6.504 12.922 6.192L14.018 5.154C14.202 5.788 14.3 6.457 14.3 7.15C14.3 11.099 11.099 14.3 7.15 14.3C3.201 14.3 0 11.099 0 7.15C0 3.201 3.201 0 7.15 0V0ZM12.792 1.89L13.82 2.918L7.13 9.621L3.95 6.441L4.979 5.411L7.131 7.564L12.791 1.889L12.792 1.89Z"
})));
const _excluded = ["id", "element", "className", "color"];
const Lodash = {
  get
};
const IS_DEV = process.env.NODE_ENV !== 'production';
const warn = function () {
  if (IS_DEV) {
    warning(...arguments);
  }
};

/**
 * Icon component
 * @typedef {import('../index').Icon}
 */
const Icon = _ref => {
  var _Object$keys;
  let {
      id: _id,
      element,
      className,
      color
    } = _ref,
    restProps = _objectWithoutProperties(_ref, _excluded);
  const id = _id === null || _id === void 0 ? void 0 : _id.toLowerCase();
  const context = useVppContext();
  const {
    loadableIcon = {},
    icons = {},
    dependencies = {}
  } = context || {};
  const {
    fallbackIcon = DefaultSVGIcon
  } = dependencies;
  const IS_STORYBOOK = typeof window !== 'undefined' && window.IS_STORYBOOK;
  const hasIcons = ((_Object$keys = Object.keys(icons)) === null || _Object$keys === void 0 ? void 0 : _Object$keys.length) > 0;
  if (/*#__PURE__*/React.isValidElement(element)) {
    return /*#__PURE__*/React.cloneElement(element, {
      className
    });
  }
  if (!id || id === 'no_logo') {
    warn(false, `icon "${id}" not found`);
    return null;
  }
  const baseProps = _objectSpread({
    id,
    className: colornames(color, className)
  }, restProps);
  if (hasIcons) {
    const Component = Lodash.get(icons, id.toUpperCase());
    if (!Component) {
      warn(false, `icon "${id}" not found`);
      return null;
    }
    return /*#__PURE__*/React.createElement(Component, baseProps);
  }
  let iconElement = loadableIcon;
  if (IS_STORYBOOK) {
    iconElement = DefaultSVGIcon;
  }
  const finalProps = IS_STORYBOOK ? baseProps : _objectSpread(_objectSpread({}, baseProps), {}, {
    fallbackIcon
  });
  return /*#__PURE__*/React.createElement(iconElement, finalProps);
};
Icon.displayName = 'Icon';
export { Icon };
